import { axiosRequest } from "helpers";

export const addressService = {
	sendAddress
};

const API_URL = process.env.REACT_APP_API_URL;

function sendAddress(model) {
	const options = {
		method: "POST",
		data: model,
		params: {
			token: model?.token,
		},
		url: `${API_URL}/api/pre_applications/${model?.applicationId}/address`,
	};
	return axiosRequest(options);
}
